import uniq from 'lodash/uniq'
import { createReducer } from 'src/utils/reducer'
import * as actions from 'src/constants/actionTypes'
import { CMDB_TEAMS_URL, TEAMS_URL } from 'src/constants/urls'

const teams = createReducer(
    {
        byId: {},
        values: [],
        searchResults: [],
        loading: false,
        modalOpen: false,
        errors: {},
        cmdbImportTeams: [],
    },
    {
        [actions.GET_CMDB_TEAMS]: (state) => {
            return {
                ...state,
                loading: true,
                searchResults: [],
            }
        },
        [actions.GET_CMDB_TEAMS_SUCCESS]: (state, action) => {
            const { results } = action.payload.data

            const searchResults = results.map((team) => team.id)
            return {
                ...state,
                byId: {
                    ...results.reduce(
                        (agg, team) => ({
                            ...agg,
                            [team.id]: team,
                        }),
                        state.byId
                    ),
                },
                values: uniq([...state.values, ...searchResults]),
                searchResults,
                loading: false,
            }
        },
        [actions.GET_CMDB_TEAMS_ERROR]: (state, action) => {
            return { ...state, loading: false }
        },
        [actions.TOGGLE_TEAM_IMPORT]: (state, action) => {
            const { teamId } = action.payload
            const { byId } = state
            return {
                ...state,
                byId: {
                    ...byId,
                    [teamId]: {
                        ...byId[teamId],
                        selected: !byId[teamId].selected,
                    },
                },
            }
        },
        [actions.TOGGLE_ALL_CONTACTS_IMPORT]: (state, action) => {
            const { checked } = action.payload
            const { byId, cmdbImportTeams } = state
            for (let i = 0; i < cmdbImportTeams.length; i++) {
                byId[cmdbImportTeams[i]].selected = checked
            }
            return {
                ...state,
                byId: { ...byId },
            }
        },
        [actions.SAVE_CMDB_TEAM_SUCCESS]: (state, action) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.teamId]: {
                        ...state.byId[action.teamId],
                        exists: true,
                    },
                },
            }
        },
    }
)

export const getCmdbTeams = (query) => {
    const url = `${CMDB_TEAMS_URL}${query ? query + '/' : ''}`
    return {
        type: actions.API,
        method: 'get',
        payload: {
            url,
            start: () => ({ type: actions.GET_CMDB_TEAMS }),
            success: (payload) => ({
                type: actions.GET_CMDB_TEAMS_SUCCESS,
                payload,
            }),
            error: (error) => ({
                type: actions.GET_CMDB_TEAMS_ERROR,
                error,
            }),
        },
        debounce: {
            key: 'searchCmdbTeams',
            wait: 500,
        },
    }
}

export const importTeam = (teamId) => (dispatch, getState) => {
    const team = getTeamById(getState(), teamId)
    dispatch({
        type: actions.API,
        method: team.exists ? 'put' : 'post',
        data: {
            id: team.id,
            name: team.name,
            email: team.email || '',
        },
        payload: {
            url: team.exists
                ? `${TEAMS_URL}${teamId ? teamId + '/' : ''}`
                : TEAMS_URL,
            start: () => ({ type: actions.SAVE_CMDB_TEAM }),
            success: (payload) => ({
                type: actions.SAVE_CMDB_TEAM_SUCCESS,
                payload,
                teamId,
            }),
            error: (error) => ({
                type: actions.SAVE_CMDB_TEAM_ERROR,
                error,
            }),
        },
    })
}

export const toggleTeamForImport = (teamId) => ({
    type: actions.TOGGLE_TEAM_IMPORT,
    payload: { teamId },
})

export const toggleAllTeamsForImport = (checked) => ({
    type: actions.TOGGLE_ALL_TEAMS_IMPORT,
    payload: {
        checked,
    },
})

export const getTeamById = (state, id) => state.cmdb.teams.byId[id]

export const getTeamSearchResults = (state) =>
    state.cmdb.teams.searchResults.map((id) => state.cmdb.teams.byId[id])

export const getTeamsForImport = (state) =>
    state.cmdb.teams.cmdbImportTeams.map((id) => state.cmdb.teams.byId[id])

export default teams
